import { Component } from '@angular/core';
import { LoadingService } from '../../../shared/fi-loading/loading.service';
import { FiADIntegrationService } from '../ad-integration.service';
import { AppTextService } from '../../../shared/app-text';
import { AdImportChooseGroupsDialogComponent } from './ad-import-choose-groups-dialog/ad-import-choose-groups-dialog.component';
import { FiDialogsService } from '../../../shared/fi-dialogs';

@Component({
    selector: 'fi-ad-external-platform-integration-ad-import',
    templateUrl: './ad-import.component.html',
    standalone: false,
})
export class FiADIntegrationADImportComponent {
    constructor(
        private loadingService: LoadingService,
        private adIntegrationService: FiADIntegrationService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    ImportAdGroupsClick() {
        this.loadingService.trackPromise(this.adIntegrationService.GetAdGroupsForImportFiltering()).then((adGroups) => {
            this.fiDialogsService
                .custom({
                    hideHeader: true,
                    yesButtonText: this.appTextService.get('common.import'),
                    noButtonText: this.appTextService.get('common.close'),
                    contentComponentRef: AdImportChooseGroupsDialogComponent,
                    contentComponentData: adGroups,
                    config: {
                        maxWidth: '600px',
                    },
                })
                .onYesButtonClick((chosenAdGroups) => {
                    const adGroupGuids = chosenAdGroups.map((item) => item.Guid);
                    this.loadingService
                        .trackPromise(this.adIntegrationService.ImportAdGroups(adGroupGuids))
                        .then(() => {
                            this.fiDialogsService.notify({
                                messageText: this.appTextService.get('ad_integration.import_success'),
                            });
                        });
                });
        });
    }
}
